import React from 'react';
import './PageHeader.scss';

const PageHeader = ({ title, children, className }) => {
  return (
    <div
      className={'d-flex align-items-center ' + (className ? className : '')}
    >
      <h1 className="page-title mr-auto">{title}</h1>
      {children}
    </div>
  );
};

export default PageHeader;
